import PropTypes from 'prop-types';
import UserBalanceImpl from './user-balance.jsx';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Text component that renders the user's current balance.
 *
 * @class UserBalance
 * @memberof Mojito.Presentation.Components
 */

/**
 * UserBalance prop types.
 *
 * @property {boolean} [hideBalance = false] - Flag controlling whether the balance value should be hidden or not.
 * @property {Mojito.Services.Authentication.types.UserInfo} [userInfo] - User info data.
 * @property {Mojito.Services.Bonus.types.FreeBet[]} [freeBets] - List of free bets.
 *
 * @memberof Mojito.Presentation.Components.UserBalance
 */
const propTypes = {
    hideBalance: PropTypes.bool,
    userInfo: PropTypes.object,
    freeBets: PropTypes.array,
};

const defaultProps = {
    hideBalance: false,
};

export default UIView('UserBalance', UserBalanceImpl, propTypes, defaultProps);
